//
// Input Overlord

function ButtonGroup() {
  this._parent = undefined;

  this.create = function () {
    this._parent = new PIXI.Container();
    var self = this;
    messageBus.subscribe("common:FullyLoaded", function () {
      var inputOverload = resourceManager.getController("inputOverlord");
      // store all buttons in group
      self._buttons = self._parent.children[0].children;

      // loop through all buttons in group
      for (var i = 0; i < self._buttons.length; ++i) {
        // lower priority button
        var prevButton = undefined;
        if (i > 0) {
          prevButton = self._buttons[i - 1];
        }

        // higher priority button
        var nextButton = undefined;
        if (i < self._buttons.length - 1) nextButton = self._buttons[i + 1];

        // this smart button
        var button = self._buttons[i];

        // the simple button that the smart button wraps up
        var simpleButtonOuter = button.children[0].children[0];

        button.isPreviousAnimating = (function (preButton) {
          return function () {
            if (!preButton) return false;
            if (preButton.isPreviousAnimating()) return true;
            if (inputOverload.isButtonInCurrentState(preButton))
              return preButton.children[0].children[0].isAnimating;
            return false;
          };
        })(prevButton);

        button.isNextAnimating = (function (neButton) {
          return function () {
            if (!neButton) return false;
            if (neButton.isNextAnimating()) return true;
            // the next button in the group might not be valid button in this state
            if (inputOverload.isButtonInCurrentState(neButton))
              return neButton.canShow();
            return false;
          };
        })(nextButton);

        // over ride can show to take into account higher priority buttons
        button.canShow = (function (
          inButton,
          previousButton,
          nexButton,
          simpleButton
        ) {
          var buttonCache = inButton;
          var canShowBaseFunc = buttonCache.canShow.bind(buttonCache);
          return function () {
            var baseShow = canShowBaseFunc();

            // if previous lower priority button is animating, dont show this over the top
            if (
              baseShow &&
              previousButton &&
              buttonCache.isPreviousAnimating()
            ) {
              baseShow = false;
            }

            // if higher priority visible then hide us
            if (baseShow && nexButton) {
              baseShow = !buttonCache.isNextAnimating();
            }

            // if we are animating, keep us visible
            if (!baseShow && simpleButton.isAnimating) {
              return true;
            }
            return baseShow;
          };
        })(button, prevButton, nextButton, simpleButtonOuter);
      }
    });
  };
}

buttonGroupCreater = {};

buttonGroupCreater.create = function () {
  var obj = new ButtonGroup();
  obj.create();
  return obj._parent;
};

buttonGroupCreater.initialise = function (json) {};

buttonGroupCreater.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "buttonGroup",
  buttonGroupCreater.create,
  buttonGroupCreater.initialise,
  buttonGroupCreater.getFilesRequired
);
